import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { loadRuntimeConfig } from './app/runtime-config';

/**
 * Render a startup failure instead of leaving a blank page. Built with DOM APIs rather
 * than innerHTML so nothing from the response can be interpreted as markup.
 */
function showStartupError(detail: string): void {
  const panel = document.createElement('div');
  panel.setAttribute('role', 'alert');
  panel.style.cssText =
    'max-width:40rem;margin:4rem auto;padding:1.5rem;border:1px solid #d9534f;' +
    'border-radius:.5rem;font-family:system-ui,sans-serif;color:#2b2b2b;background:#fff';

  const heading = document.createElement('h1');
  heading.textContent = 'Civie-AI could not start';
  heading.style.cssText = 'margin:0 0 .75rem;font-size:1.15rem;color:#b52b27';

  const summary = document.createElement('p');
  summary.textContent =
    'The application is missing its runtime configuration, so it does not know which ' +
    'backend to use. Please contact support with the detail below.';
  summary.style.cssText = 'margin:0 0 .75rem;line-height:1.5';

  const detailBlock = document.createElement('pre');
  detailBlock.textContent = detail;
  detailBlock.style.cssText =
    'margin:0;padding:.75rem;background:#f5f5f5;border-radius:.25rem;' +
    'white-space:pre-wrap;word-break:break-word;font-size:.85rem';

  panel.append(heading, summary, detailBlock);
  document.body.replaceChildren(panel);
}

// Resolve the backend URL from /config.json before anything can issue a request.
loadRuntimeConfig()
  .then(() => bootstrapApplication(AppComponent, appConfig))
  .catch((err) => {
    console.error(err);
    showStartupError(err instanceof Error ? err.message : String(err));
  });
